module.exports = __webpack_public_path__ + "assets/b6e6b2eec542d742f59f6afd77112a5d.mp3";


/*****************
 ** WEBPACK FOOTER
 ** ./public-src/sounds/win/BigWin_3.mp3
 ** module id = 215
 ** module chunks = 0
 **/